module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Global-Landing-Page.dd1f2d53.jpg";